import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './Page_DiseaseProfile.scss';
import { EventType_Create, EventType_Delete, EventType_DeleteMulti, LL_V_L, ModuleFE_AppConfig, ProtoComponent } from '@nu-art/thunderstorm-frontend/index';
import { asArray } from '@nu-art/ts-common';
import { TS_HorizontalWorkspace, TS_Workspace } from '@nu-art/ts-workspace-frontend/index';
import { Page_DiseaseProfile_Header } from '../Page_DiseaseProfile_Header/Page_DiseaseProfile_Header.js';
import { Panel_DiseaseViews, Panel_DPView_ContentSelector } from '../../panels/index.js';
import { ModuleFE_DiseaseProfile } from '../../../_entity.js';
import { ModulePackFE_DiseaseProfile } from '../../../module-pack.js';
import { ModuleFE_Book, ModuleFE_Reference, ModuleFE_Value, ModuleFE_Variable } from '@app/hcs-frontend';
import { RoutePermissions } from '@nu-art/permissions-frontend/index';
import { DBDef_DiseaseProfile } from '@app/dp-shared';
const renderers = {
    horizontalSpace: TS_HorizontalWorkspace,
    diseasePropertyPanel: Panel_DiseaseViews,
    propertyDataPanel: Panel_DPView_ContentSelector,
};
export class Page_DiseaseProfile extends ProtoComponent {
    // ######################### Static #########################
    static Route = {
        key: 'disease-profiles',
        path: 'disease-profiles',
        Component: this,
        enabled: RoutePermissions(ModuleFE_DiseaseProfile.permissions.ui.Release),
        modulesToAwait: [ModuleFE_AppConfig, ...ModulePackFE_DiseaseProfile, ModuleFE_Variable, ModuleFE_Value, ModuleFE_Reference, ModuleFE_Book],
    };
    static defaultProps = {
        keys: ['selected'],
    };
    workspaceKey = 'disease-profiles';
    // ######################### Life Cycle #########################
    __onDiseaseProfileUpdated(...params) {
        switch (params[0]) {
            case EventType_Create: {
                return this.reSelectDP();
            }
            case EventType_Delete:
            case EventType_DeleteMulti: {
                const dps = asArray(params[1]);
                if (dps.find(dp => dp._id === this.state.selectedDiseaseProfileId))
                    return this.reSelectDP();
            }
        }
    }
    deriveStateFromProps(nextProps, state) {
        state.selectedDiseaseProfileId = this.getQueryParam('selected', {})[DBDef_DiseaseProfile.dbKey];
        if (state.selectedDiseaseProfileId)
            return state;
        //Set a disease profile if one none selected
        const firstDP = ModuleFE_DiseaseProfile.cache.all()[0];
        if (!firstDP)
            return state;
        const selected = { ...this.getQueryParam('selected', {}) };
        selected[DBDef_DiseaseProfile.dbKey] = firstDP._id;
        state.selectedDiseaseProfileId = firstDP._id;
        this.logInfo(`Setting new DP ID ${firstDP._id}`);
        this.setQueryParam('selected', selected);
        return state;
    }
    // ######################### Logic #########################
    reSelectDP = () => {
        const firstDP = ModuleFE_DiseaseProfile.cache.all()[0];
        const currentSelectedDP = ModuleFE_DiseaseProfile.cache.unique(this.state.selectedDiseaseProfileId);
        //If starting out without a selected DP or the selected DP is not in the cache
        if (!this.state.selectedDiseaseProfileId || !currentSelectedDP) {
            const selected = { ...this.getQueryParam('selected', {}) };
            if (!firstDP)
                delete selected[DBDef_DiseaseProfile.dbKey];
            else
                selected[DBDef_DiseaseProfile.dbKey] = firstDP._id;
            this.setQueryParam('selected', selected);
        }
    };
    // ######################### Render #########################
    renderWorkspace = () => {
        if (!this.state.selectedDiseaseProfileId)
            return _jsx("div", { className: 'dp-page-message', children: "No disease profile selected" });
        return _jsx(TS_Workspace, { renderers: renderers, workspaceKey: this.workspaceKey });
    };
    render() {
        return _jsxs(LL_V_L, { id: 'page__disease-profile', children: [_jsx(Page_DiseaseProfile_Header, {}), this.renderWorkspace()] });
    }
}
//# sourceMappingURL=Page_DiseaseProfile.js.map